var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ConditionKind } from '../Model/ConditionKind';
var LocationMatchCondition = /** @class */ (function () {
    function LocationMatchCondition(conditions) {
        this._conditions = conditions;
    }
    Object.defineProperty(LocationMatchCondition.prototype, "canBeCached", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    LocationMatchCondition.prototype.check = function () {
        var _this = this;
        if (!this._conditions || !this._conditions.length) {
            return false;
        }
        var condition = this._conditions.filter(function (condition) {
            return condition.check();
        }).sort(function (conditionA, conditionB) {
            return _this.compare(conditionA, conditionB);
        })[0];
        return condition && condition.kind === ConditionKind.UrlMatch;
    };
    LocationMatchCondition.prototype.strength = function (condition) {
        var matches = condition.matches();
        if (matches === null) {
            return Number.MIN_VALUE;
        }
        return matches.reduce(function (acc, match) {
            return acc - match.length;
        }, condition.matchUrl().length);
    };
    LocationMatchCondition.prototype.compare = function (conditionA, conditionB) {
        var strengthA = this.strength(conditionA);
        var strengthB = this.strength(conditionB);
        if (strengthA === strengthB) {
            var urlLengthA = conditionA.matchUrl().length;
            var urlLengthB = conditionB.matchUrl().length;
            return urlLengthA === urlLengthB ? 0 : (urlLengthA > urlLengthB ? -1 : 1);
        }
        return strengthA > strengthB ? -1 : 1;
    };
    return LocationMatchCondition;
}());
export { LocationMatchCondition };
var BaseUrlMatchCondition = /** @class */ (function () {
    function BaseUrlMatchCondition(condition) {
        this._condition = condition;
    }
    BaseUrlMatchCondition.prototype.matchUrl = function () {
        var matchQueryParams = this._condition.parameter.indexOf('?') >= 0;
        return window.location.pathname + (matchQueryParams ? window.location.search : '');
    };
    BaseUrlMatchCondition.prototype.matches = function () {
        var matches = this.matchUrl().match(this.stringToRegexp(this._condition.parameter));
        return matches ? matches.slice(1) : null;
    };
    BaseUrlMatchCondition.prototype.stringToRegexp = function (input) {
        return new RegExp('^' + input
            .replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
            .replace(/\\\*/g, '(.*)') + '$');
    };
    return BaseUrlMatchCondition;
}());
var UrlMatchCondition = /** @class */ (function (_super) {
    __extends(UrlMatchCondition, _super);
    function UrlMatchCondition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UrlMatchCondition.prototype, "kind", {
        get: function () {
            return ConditionKind.UrlMatch;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UrlMatchCondition.prototype, "canBeCached", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    UrlMatchCondition.prototype.check = function () {
        return this.matches() !== null;
    };
    return UrlMatchCondition;
}(BaseUrlMatchCondition));
export { UrlMatchCondition };
var UrlNotMatchCondition = /** @class */ (function (_super) {
    __extends(UrlNotMatchCondition, _super);
    function UrlNotMatchCondition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UrlNotMatchCondition.prototype, "kind", {
        get: function () {
            return ConditionKind.UrlNotMatch;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UrlNotMatchCondition.prototype, "canBeCached", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    UrlNotMatchCondition.prototype.check = function () {
        return this.matches() !== null;
    };
    return UrlNotMatchCondition;
}(BaseUrlMatchCondition));
export { UrlNotMatchCondition };
